// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__xTB0y","searchBar":"SearchBar_searchBar__yiJZ8","searchLogo":"SearchBar_searchLogo__gvtwW"};